module.exports = __webpack_public_path__ + "static/laravel-dbc8e8bf922cbf492be08e1f42d009ab.png";